var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"red-hat-medium"},[_c('div',{staticClass:"snackbar",style:({ backgroundColor:_vm.backgroundColor })},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6881934","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Snackbar.vue
// module id = 209
// module chunks = 354